import { make } from 'vuex-pathify';
import { keys, keyBy, sortBy } from 'lodash';

const responses = keyBy(
    [
        {
            id: 1,
            text: 'Queenie should give the nurse a piece of her mind – let her have it!',
            type: 'aggressive',
            isCorrect: false
        },
        {
            id: 2,
            text: 'Queenie should just take off, “Forget this lady, I’m out of here!”',
            type: 'passive',
            isCorrect: false
        },
        {
            id: 3,
            text: 'Queenie should ask to see another service representative.',
            type: 'assertive',
            isCorrect: true
        }
    ],
    'id'
);
const responsesOrder = sortBy(keys(responses), k => parseInt(k));
const goalBlurbs = {
    Health:
        'As you just saw from Queenie’s experience, assertive communication with health service staff helped her get her needs met and will help you meet your health goals.',
    Education:
        'Assertive communication can be helpful in an educational setting. For example, it can help if you are dealing with a teacher who isn’t helping you understand the material or other students who are bullying you.',
    Career:
        'Assertive communication is important in the workforce! You can’t be aggressive with your co-workers or your boss. And if you work in customer service or with clients, being aggressive could get you fired! But you can’t let people walk all over you, either. Being assertive can help you be successful in any job.',
    Relationships:
        'Just like Ron and Billi, you have to assert yourself with friends, family, and partners. We’ll talk more about how assertive communication can help you talk to your partners about safer sex later on.',
    Finances:
        'Let’s say you’re trying to get your money’s worth for something you want to buy, or maybe someone stole your credit card and you’re dealing with your credit card company. Assertive communication can help you in those situations and keep you on track with all your financial goals.',
    Stability:
        'Assertive communication can come in handy if you are having issues with a roommate or landlord. It’s also helpful if you are trying to get services like help with housing or other things related to your stability goals.',
    Hobbies:
        'Being assertive helps make sure that your hobbies are fun and relaxing, not stressful! For example, if your hobby is dancing with your friends, but you have a disagreement about the choreography, being assertive helps you make your case for what you want, and helps you all continue dancing and having fun together.',
    Other: 'Assertive communication is a good approach in any scenario to help you express your needs and help meet your goals.'
};

const state = {
    title: 'Healthcare Barriers',
    complete: false,
    sticker: {
        text: 'Stethoscope',
        earned: false,
        image: require('@/assets/stickers/stickers_0018_stethescope.png')
    },
    bonusSticker: false,
    trophy: {
        text: 'Toolbox',
        earned: false,
        image: require('@/assets/trophies/trophy_0001_toolbox.png')
    },
    comics: [
        require('@/assets/comics/Comic04-1.png'),
        require('@/assets/comics/Comic04-2.png'),
        require('@/assets/comics/Comic04-3.png'),
        require('@/assets/comics/Comic04-4.png'),
        require('@/assets/comics/Comic04-5.png')
    ],
    comic: 0,
    responses,
    responsesOrder,
    socialPost: '',
    goalBlurbs
};
const getters = make.getters(state);
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
